<script>
    import { Loading } from "attractions";
</script>

<section class="loadingContent">
    <Loading />
</section>

<style lang="scss">
    .loadingContent {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100vw;
        height: 100vh;
    }
</style>